import React from 'react';
import PropTypes from 'prop-types';

const baseCls = 'checkout-sidebar-tourists__gender';

const Gender = ({ type }) => (
  <div className={`${baseCls} ${baseCls}_${type.toLowerCase()}`} />
);

Gender.propTypes = {
  type: PropTypes.oneOf(['M', 'F']).isRequired,
};

export default Gender;
